var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"preview",staticClass:"pz-sql-preview overflow-auto"},[_vm._v(" "+_vm._s(_vm.query)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }